import type {GetTeams_teams as Team} from 'nutshell-graphql-types';

import {getEntities} from './mentions-utils';
import type {MentionConfig} from './rich-textarea';

export function getMentionsConfig(): MentionConfig {
    return {
        enabled: true,
        getMentions: (searchTerm: string, teams?: Team[] | null) => {
            return getEntities(searchTerm, teams).then((response) => {
                return {matches: response};
            });
        },
    };
}
